import React from "react";
import { Modal } from "@pd/pd-ui-kit";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

interface CopyRoleModalProps {
  copyRoleId: string | null;
  setCopyRoleId: (val: string | null) => void;
  copyRoleMutation: { isLoading: boolean };
  doCopy: (val: string) => void;
  openChildModal: string | undefined;
  closeModalUser: () => void;
}

export const CopyRoleModal = (props: CopyRoleModalProps) => {
  const {
    copyRoleId,
    setCopyRoleId,
    copyRoleMutation,
    doCopy,
    openChildModal,
    closeModalUser,
  } = props;

  const { t } = useTranslation();
  const history = useHistory();

  return (
    <>
      <Modal
        open={copyRoleId !== null}
        onCancel={() => setCopyRoleId(null)}
        title={t("ui.confirm_action")}
        cancelButton={{
          children: t(`roles.cancel`),
          disabled: copyRoleMutation.isLoading,
        }}
        okButton={{
          children: t(`roles.copy`),
          onClick: () => copyRoleId && doCopy(copyRoleId),
          disabled: copyRoleMutation.isLoading,
        }}
        centered
      >
        {t(`roles.copyConfirmTitle`)}
      </Modal>
      <Modal
        open={!!openChildModal}
        onCancel={closeModalUser}
        centered
        title={"Действие выполнено"}
        cancelButton={{ children: "Остаться" }}
        okButton={{
          children: "Перейти к скопированной роли",
          onClick: () =>
            history.push(`/registry_of_role/${openChildModal}?status=copy`),
        }}
      >
        Роль скопирована
      </Modal>
    </>
  );
};
